import { configureStore } from "@reduxjs/toolkit";
import preloadReducer from "./slices/preloadSlice";
import userReducer from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    preload: preloadReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;